import axios from 'axios';
import { defaultbaseUrl } from '../config'

const API_URL = defaultbaseUrl;

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'login', {
        email: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data) {
          localStorage.setItem('user', JSON.stringify(response.data));
          const headers = window.Echo && window.Echo.connector && window.Echo.connector.options
            && window.Echo.connector.options.auth && window.Echo.connector.options.auth.headers;
          if (headers && response.data.token) {
            headers.Authorization = 'Bearer ' + response.data.token;
          }
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
    const headers = window.Echo && window.Echo.connector && window.Echo.connector.options
      && window.Echo.connector.options.auth && window.Echo.connector.options.auth.headers;
    if (headers) delete headers.Authorization;
  }
}

export default new AuthService();
